import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/reducer/projectSlice";
import { changePasswordApiCall } from "../../store/actions/projectAction";

function ChangePasswordForm() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const newPassword = watch("newPassword");

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      dispatch(
        setLoading({
          code: "password_change",
          loading: true,
        })
      );

      await dispatch(
        changePasswordApiCall({
          data: {
            confirmPassword: data.confirmPassword,
            password: data.newPassword,
          },
        })
      );

      dispatch(
        setLoading({
          code: "password_change",
          loading: false,
        })
      );
    } catch (error) {
      console.log(error, "error");
      dispatch(
        setLoading({
          code: "password_change",
          loading: false,
        })
      );
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-white p-6 rounded-xl shadow-md border border-gray-200"
    >
      <h2 className="text-xl font-semibold text-gray-700 mb-6 border-b pb-3">
        Change Password
      </h2>
      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            New Password
          </label>
          <input
            type="text"
            {...register("newPassword", {
              required: "New password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters",
              },
            })}
            placeholder="••••••••"
            className="w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          {errors.newPassword && (
            <p className="text-red-500 text-sm mt-1">
              {errors.newPassword.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Confirm New Password
          </label>
          <input
            type="text"
            {...register("confirmPassword", {
              required: "Please confirm password",
              validate: (value) =>
                value === newPassword || "Passwords do not match",
            })}
            placeholder="••••••••"
            className="w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          {errors.confirmPassword && (
            <p className="text-red-500 text-sm mt-1">
              {errors.confirmPassword.message}
            </p>
          )}
        </div>

        <button
          type="submit"
          className="bg-[#00428C] text-white px-6 py-2 rounded-lg mt-4 hover:bg-blue-700"
        >
          Change Password
        </button>
      </div>
    </form>
  );
}

export default ChangePasswordForm;
